import { FC, useState } from 'react';
import { useSnackbar } from 'notistack';
import { Modal } from '../../../components';
import { Fade, Typography, Button, Box, ButtonGroup, TextField } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { Save } from '@mui/icons-material';
import { IOrderDetail } from '../../../models';
import { createOrderFavorite } from '../../../fetch';

interface IFavoriteModal {
  open: boolean;
  handleClose: (shouldRefresh?: boolean) => void;
  currentOrder: IOrderDetail;
}

export const FavoriteModal: FC<IFavoriteModal> = ({ open, handleClose, currentOrder }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [favoriteName, setFavoriteName] = useState<string>('');
  const [isSaving, setSaving] = useState<boolean>(false);
  return (
    <Modal
      open={open}
      onClose={e => {
        setFavoriteName('');
        handleClose();
      }}
      maxWidth="xs"
    >
      <Fade in={open}>
        <div>
          <Typography align="center" variant="h5" component="h4" gutterBottom>
            Add to Favorites
          </Typography>
          <Typography align="center" paragraph>
            Please provide a name for this favorite.
          </Typography>
          <Box marginBottom="1rem">
            <TextField
              size="small"
              fullWidth
              variant="outlined"
              autoComplete="nope"
              label="Name"
              name="name"
              required
              value={favoriteName}
              onChange={e => setFavoriteName(e.target.value)}
            />
          </Box>
          <Box display="flex" justifyContent="center">
            <ButtonGroup>
              <LoadingButton
                loading={isSaving}
                loadingPosition="start"
                startIcon={<Save />}
                onClick={async () => {
                  setSaving(true);
                  try {
                    await createOrderFavorite(currentOrder.fieldOrderId, favoriteName);
                    enqueueSnackbar('Favorite order saved!', {
                      variant: 'success'
                    });
                    handleClose(true);
                  } catch (error) {
                    enqueueSnackbar(`Error saving favorite.`, {
                      variant: 'error'
                    });
                  } finally {
                    setSaving(false);
                  }
                }}
                variant="contained"
                color="primary"
                disabled={!favoriteName}
              >
                Save
              </LoadingButton>
              <Button
                variant="contained"
                color="inherit"
                onClick={() => {
                  setFavoriteName('');
                  handleClose();
                }}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </Box>
        </div>
      </Fade>
    </Modal>
  );
};
